import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { getAccountHome } from '../../services/account/account_home';
import CustomLoading from '../../components/customLoading/CustomLoading';

function AccountHome() {
    const [loading, setLoading] = useState(false);
    const [globalMetrics, setGlobalMetrics] = useState([
        { title: "Total Pending Package Invoice", count: "--" },
        { title: "Total Pending Medicine Invoice", count: "--" },
        { title: "Total Pending Consultation Invoice", count: "--" },
    ]);
    const [centerWiseMetrics, setCenterWiseMetrics] = useState({});

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getAccountHome();
            if (res.status === 200) {
                const data = res.data;
                setGlobalMetrics([{ title: "Total Pending Package Invoice", count: data.global_metrics.total_pending_package_invoice },
                { title: "Total Pending Medicine Invoice", count: data.global_metrics.total_pending_medicine_invoice },
                { title: "Total Pending Consultation Invoice", count: data.global_metrics.total_pending_consultation_invoice },
                ]);
                setCenterWiseMetrics(data.center_wise_metrics);
            } else {
                toast.error("Unable to fetch Invoice");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Invoice:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', },
        ]} />
        {
            loading ?
                <CustomLoading /> :
                <>
                    <div className="mt-4">
                        <StyledHeadingText text={"Global Metrics"} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-2 mb-4">
                        {globalMetrics.map((card, index) => (
                            <Card key={index} title={card.title} count={card.count} />
                        ))}
                    </div>
                    <StyledHeadingText text={"Center Wise Metrics"} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-2">
                        {Object.entries(centerWiseMetrics).map(([centerName, metrics]) => (
                            <div
                                key={metrics.center_id}
                                className="bg-white shadow-lg rounded-lg p-4 flex flex-col justify-between"
                            >
                                <h3 className="text-lg font-bold text-primary">{centerName}</h3>
                                <hr />
                                <div className="mt-2 text-sm">
                                    <p className="text-gray-600">
                                        <strong>Pending Package Invoices:</strong> {metrics.pending_package_invoice}
                                    </p>
                                    <p className="text-gray-600">
                                        <strong>Pending Medicine Invoices:</strong> {metrics.pending_medicine_invoice}
                                    </p>
                                    <p className="text-gray-600">
                                        <strong>Pending Consultation Invoices:</strong> {metrics.pending_consultation_invoice}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
        }
    </>);
}

export default AccountHome;